import { useCallback } from "react";
import { Node, useReactFlow } from "@xyflow/react";
import { onNodeClickAtom } from "@zapier/canvas-state";
import { useSetAtom } from "jotai";

import useGetNodeDataByTypeFn from "../../hooks/useGetNodeDataByTypeFn";
import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";

export function useOnNodeClick(
  ref: React.MutableRefObject<HTMLDivElement | null>,
) {
  const { screenToFlowPosition, getIntersectingNodes } = useReactFlow();
  const getNodeDataByType = useGetNodeDataByTypeFn();
  const { emitEventOnAddStep, emitEventOnAddPath } =
    useEmitUserInteractionEvents();
  const onNodeClickCommand = useSetAtom(onNodeClickAtom);

  const onNodeClick = useCallback(
    (event: React.MouseEvent, node: Node) => {
      onNodeClickCommand({
        event,
        node,
        ref,
        emitEventOnAddStep,
        emitEventOnAddPath,
        screenToFlowPosition,
        getIntersectingNodes,
        getNodeDataByType,
      });
    },
    [
      onNodeClickCommand,
      emitEventOnAddPath,
      emitEventOnAddStep,
      getIntersectingNodes,
      getNodeDataByType,
      ref,
      screenToFlowPosition,
    ],
  );

  return { onNodeClick };
}
